const slugify = require('slugify');

exports.slugifyUrl = (url) => {
  const slug = slugify(url, {
    replacement: '-', // replace spaces with replacement character, defaults to `-`
    remove: undefined, // remove characters that match regex, defaults to `undefined`
    lower: true, // convert to lower case, defaults to `false`
    strict: true, // strip special characters except replacement, defaults to `false`
    trim: true, // trim leading and trailing replacement chars, defaults to `true`
  });

  return slug;
};

exports.removeDuplicateIgnoreCaseAndSpecialCharacter = (elements) => {
  const majors = new Map();
  elements.map((s) =>
    s
      ? majors.set(
          s
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase(),
          s
        )
      : ''
  );
  return [...majors.values()];
};

exports.containsIgnoreCaseAndSpecialCharacters = (elementArray, element) => {
  return elementArray.some((s) => normalize(s) === normalize(element));
};

function normalize(string) {
  return string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
